const ERROR_FIELD_SELECTOR = ".v-input.error--text"

export const getErrorTextField = () => document.querySelector(ERROR_FIELD_SELECTOR) as HTMLElement
